/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const ApiMobileValidationWorkflowsListParams = zod.strictObject({
    app_id: zod.string().optional(),
    last_sync: zod.iso.datetime({ offset: true }).optional(),
    limit: zod.number().optional(),
    page: zod.number().optional(),
});

export type ApiMobileValidationWorkflowsListParams = zod.input<
    typeof ApiMobileValidationWorkflowsListParams
>;
export type ApiMobileValidationWorkflowsListParamsOutput = zod.output<
    typeof ApiMobileValidationWorkflowsListParams
>;
